import * as React from 'react'

import { useArcadeMigrationFeatureFlag } from '../../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeLoadingImage from './ArcadeLoadingImage'
import MooncakeLoadingImage from './MooncakeLoadingImage'

type LoadingImageProps = {
  alt: string
  placeholderHeight: string
  placeholderWidth?: string
} & React.ImgHTMLAttributes<HTMLImageElement>

/**
 * @deprecated Use ArcadeLoadingImage instead
 */
const LoadingImage = (props: LoadingImageProps) => {
  const shouldUseArcadeLoadingImage = useArcadeMigrationFeatureFlag('loading-image')

  if (shouldUseArcadeLoadingImage) {
    return <ArcadeLoadingImage {...props} />
  }

  return <MooncakeLoadingImage {...props} />
}

export default LoadingImage
